import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import Stream from "../components/Image/Stream.svg"
import Artwork from "../components/Image/Artwork.svg"
import Statistic from "../components/Image/StatisticMobile.svg"
import Request from "../../based/Request";
import Logo from "../components/Image/LogoArtist.svg"
import Background from "../components/Image/BG_Artist.png"
import ModalUpdateInfo from "../components/ModalUpdateInfo";
function MainMobile() {
    const history = useHistory()
    const [user, setUser] = useState({})
    const [isModal, setIsModal] = useState(false)



    useEffect(() => {
        getPersonalInfo();
    }, []);


    function getPersonalInfo() {
        Request.Get("/api/Artist/get-artist-info")
            .then((res) => {
                let data = res.data;
                setUser(data);
            })
            .catch((err) => {});
    }

    
    
    return ( 
        <MainMobileStyle>
            <div className="header-mobile">
                <div className="name-user">
                    <span>
                        Xin chào,
                    </span>
                    <span className="name">
                    {user.nickName ? user.nickName : user.firstName && user.lastName && user.firstName + " " + user.lastName}
                    </span>
                </div>
                <div className="avatar-user" onClick={()=>{setIsModal(true)}}>
                {user.avatar ? <img src={user.avatar} alt="avatar" /> : <img src={Logo} alt="avatar mặc định" />}
                </div>
            </div>
            <div className="row-main">
                <div className="col-main mobile-600">
                    <div className="item" onClick={()=>{
                        history.push(`/artist/stream`);
                    }}>
                        <img src={Stream} alt="Livestream" />
                    </div>
                </div>
                <div className="col-main mobile-600">
                    <div className="item" onClick={()=>{
                        history.push(`/artist/artwork`);
                    }}>
                        <img src={Artwork} alt="Artwork" />
                    </div>
                </div>
                <div className="col-main" hidden>
                    <div className="item" onClick={()=>{
                        history.push(`/artist/statistic`);
                    }}>
                        <img src={Statistic} alt="Thống kê" />
                    </div>
                </div>
                {/* <div className="col-main">
                    <div className="desc btn-update" onClick={()=>{setIsModal(true)}}>Chỉnh sửa thông tin</div>
                    <div className="desc" onClick={handleLogout}>Đăng xuất</div>
                </div> */}

            </div>
           
            {isModal && <ModalUpdateInfo setIsModal={setIsModal} user={user} getPersonalInfo={getPersonalInfo} />}
        </MainMobileStyle>
    );
}
const MainMobileStyle = styled.div`
    width: 100%;
    background-color: #313131;
    display: flex;
    flex-direction: column;
    min-height: 100svh;



   
        
    .row-main{
        display: flex;
        flex-wrap: wrap;
        padding: 0 16px 16px;
        margin-top: -40px;

        .col-main{
            width: 100%;
            margin-top: 16px;
        
            .item{
                width: 100%;
                border-radius: 10px;
                cursor: pointer;

                img{
                    width: 100%;

                }
            }


            .desc{
                height: 42px;
                width: 100%;
                margin-top: 5px;
                font-weight: 500;
                font-size: 14px;
                line-height: 18px;
                letter-spacing: -0.3px;
                color: #06F1B9;
                display: grid;
                place-items: center;
                cursor: pointer;
    
    
                &.btn-update{
                    background-color: #464646;
                    border-radius: 10px;
                }
    
            }

        }

    }

    .header-mobile{
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        padding: 32px 24px 24px;
        height: 365px;
        background-image:linear-gradient(to bottom, rgba(49,49, 49, 0), rgba(49,49, 49, 1)), url(${Background});
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;

        .name-user{

            span{
                font-weight: 600;
                font-size: 20px;
                line-height: 25px;
                letter-spacing: -0.3px;
                color: #FFFFFF;

                &.name{
                    color: #06F1B9;
                    margin-left: 7px;
                }

            }

            
        }

        .avatar-user{
            width: 42px;
            height: 42px;
            border-radius: 50%;

            img{
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 50%;
                border: 2px solid #06F1B9;

            }
        }
    }

    @media (min-width: 600px){
        .row-main{
           
    
            .mobile-600{
                width: (50% - 5px);
                margin-top: 16px;
            
                .item{
                    width: 100%;
                    border-radius: 10px;
                    cursor: pointer;
    
                    img{
                        width: 100%;
    
                    }
                }
    
            }
    
        }
    }

`
export default MainMobile;


// WEBPACK FOOTER //
// ./src/artist-ui/Main/MainMobile.js